<div class="layout">
  <app-sidebar-menu></app-sidebar-menu>
  <div class="main-panel">
    <header class="topbar">
      <h1>{{ titulo }}</h1>
      <div class="topbar-right">
        <app-accessibility-toolbar></app-accessibility-toolbar>
        <app-user-session-summary></app-user-session-summary>
      </div>
    </header>
    <main class="content">
      <section class="card">
        <h2>{{ titulo }}</h2>
        <p>Modulo en construccion para rol: <strong>{{ rol }}</strong>.</p>
        <a routerLink="/principal" [queryParams]="{ role: rol }">Volver al inicio</a>
      </section>
    </main>
  </div>
</div>
